import React from "react";

const OTPContent = () => {
  return <div>OTPContent</div>;
};

export default OTPContent;
